import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { submitFormData } from "../../Utils/adminFunctions";
const ImportData = () => {
  const [categoryCsv, setCategoryCsv] = useState("");
  const [professionCsv, setProfessionCsv] = useState("");
  const [regionCsv, setRegionCsv] = useState("");
  const [countryCsv, setCountryCsv] = useState("");
  const [stateCsv, setStateCsv] = useState("");
  const [errorCategoryCsv, setErrorCategoryCsv] = useState("");
  const [errorProfessionCsv, setErrorProfessionCsv] = useState("");
  const [errorRegionCsv, setErrorRegionCsv] = useState("");
  const [errorCountryCsv, setErrorCountryCsv] = useState("");
  const [errorStateCsv, setErrorStateCsv] = useState("");
  const [desabledBtn, setDesabledBtn] = useState(false);
  let handleCategoryCsv = (csvcategory) => {
    if (csvcategory) {
      setCategoryCsv(csvcategory);
    } else {
      setCategoryCsv("");
    }
  };
  let handleProfessionCsv = (csvprofession) => {
    if (csvprofession) {
      setProfessionCsv(csvprofession);
    } else {
      setProfessionCsv("");
    }
  };
  let handleRegionCsv = (csvregion) => {
    if (csvregion) {
      setRegionCsv(csvregion);
    } else {
      setRegionCsv("");
    }
  };
  let handleCountryCsv = (csvcountry) => {
    if (csvcountry) {
      setCountryCsv(csvcountry);
    } else {
      setCountryCsv("");
    }
  };
  let handleStateCsv = (csvstate) => {
    if (csvstate) {
      setStateCsv(csvstate);
    } else {
      setStateCsv("");
    }
  };
  const importCategory = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (categoryCsv === "") {
      setErrorCategoryCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (categoryCsv !== "" && !categoryCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("category_csv", categoryCsv);
    const response = await submitFormData("importCategory", bodyFormData);
    if (response.status === "success") {
      document.getElementById("categorycsv").value = "";
      setCategoryCsv("");
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    }
  };
  const importProfession = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (professionCsv === "") {
      setErrorProfessionCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (professionCsv !== "" && !professionCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("spacialization_csv", professionCsv);
    const response = await submitFormData("importSpacialization", bodyFormData);
    if (response.status === "success") {
      document.getElementById("spacializationcsv").value = "";
      setProfessionCsv("");
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    }
  };

  const importRegion = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (regionCsv === "") {
      setErrorRegionCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (regionCsv !== "" && !regionCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("region_csv", regionCsv);
    const response = await submitFormData("importRegion", bodyFormData);
    if (response.status === "success") {
      document.getElementById("regioncsv").value = "";
      setRegionCsv("");
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    }
  };
  const importCountry = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (countryCsv === "") {
      setErrorCountryCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (countryCsv !== "" && !countryCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("country_csv", countryCsv);
    const response = await submitFormData("importCountry", bodyFormData);
    if (response.status === "success") {
      document.getElementById("countrycsv").value = "";
      setCountryCsv("");
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    }
  };
  const importState = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (stateCsv === "") {
      setErrorStateCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (stateCsv !== "" && !stateCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("state_csv", stateCsv);
    const response = await submitFormData("importState", bodyFormData);
    if (response.status === "success") {
      document.getElementById("statecsv").value = "";
      setStateCsv("");
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    }
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer />
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12"></div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row p-5 border-bottom">
                          <div className="col-md-1">
                            <label>Category</label>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="file"
                                id="categorycsv"
                                accept="csv/*"
                                className={
                                  errorCategoryCsv ? " is-invalid" : ""
                                }
                                onChange={(e) => {
                                  setErrorCategoryCsv("");
                                  handleCategoryCsv(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary mb-2"
                                onClick={importCategory}
                                disabled={desabledBtn}
                              >
                                Import
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row p-5 border-bottom">
                          <div className="col-md-1">
                            <label>Specialization</label>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="file"
                                id="spacializationcsv"
                                accept="csv/*"
                                className={
                                  errorProfessionCsv ? " is-invalid" : ""
                                }
                                onChange={(e) => {
                                  setErrorProfessionCsv("");
                                  handleProfessionCsv(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary mb-2"
                                onClick={importProfession}
                                disabled={desabledBtn}
                              >
                                Import
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row p-5 border-bottom">
                          <div className="col-md-1">
                            <label>Region</label>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="file"
                                id="regioncsv"
                                accept="csv/*"
                                className={errorRegionCsv ? " is-invalid" : ""}
                                onChange={(e) => {
                                  setErrorRegionCsv("");
                                  handleRegionCsv(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary mb-2"
                                onClick={importRegion}
                                disabled={desabledBtn}
                              >
                                Import
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row p-5 border-bottom">
                          <div className="col-md-1">
                            <label>Country</label>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group mx-sm-3 mb-2">
                              <input
                                type="file"
                                id="countrycsv"
                                accept="csv/*"
                                className={errorCountryCsv ? " is-invalid" : ""}
                                onChange={(e) => {
                                  setErrorCountryCsv("");
                                  handleCountryCsv(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary mb-2"
                                onClick={importCountry}
                                disabled={desabledBtn}
                              >
                                Import
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row p-5">
                          <div className="col-md-1">
                            <label>State</label>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group mx-sm-3 mb-2">
                              <input
                                type="file"
                                id="statecsv"
                                accept="csv/*"
                                className={errorStateCsv ? " is-invalid" : ""}
                                onChange={(e) => {
                                  setErrorStateCsv("");
                                  handleStateCsv(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary mb-2"
                                onClick={importState}
                                disabled={desabledBtn}
                              >
                                Import
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};
export default ImportData;
